/**
 * @ngdoc services
 * @memberof mercury.modules.reports
 * @name ReportItemCategories
 * @description Data access service for POS Item Categories (Food, Beverage etc)
 */
angular.module('mercury.modules.reports.items')
.factory('ReportItemCategories', ["$http", "$q", "$resource", "settings", function($http, $q, $resource, settings) {
  var ItemCategorySales = $resource(settings.mercHost + '/pos/items/category-sales');
  var ItemCategoryOrders = $resource(settings.mercHost + '/pos/items/category-orders');

  /**
   * Get total sales between start and end grouped by item category
   *
   * @memberof ReportItemCategories
   * @param  {String} start start of report period
   * @param  {String} end end of report period
   * @return {Object} Service promise
   */
  function getSales(start, end, companyId) {
    var deferred = $q.defer();
    var config = {params: {start: start, end: end}};

    // Optionally override the company-id header
    if (companyId) {
      config.headers = {
        'x-loaded-company-id': companyId,
        'x-loaded-suppress-subscription-errors': '1'
      };
    }

    $http.get(settings.mercHost + '/pos/items/category-sales', config)
    .then(function(result) {
      deferred.resolve(result.data);
    }, function(result) {
      deferred.reject(result.data);
    });

    return deferred.promise;
  }

  /**
   * Get total sales between start and end grouped by item category
   *
   * @memberof ReportItemCategories
   * @param  {String} start start of report period
   * @param  {String} end end of report period
   * @return {Object} Service promise
   */
  function getOrders(start, end) {
    var deferred = $q.defer();

    $http.get(settings.mercHost + '/pos/items/category-orders', {
      params: {start: start, end: end}
    })
    .then(function(result) {
      deferred.resolve(result.data);
    }, function(result) {
      deferred.reject(result.data);
    });

    return deferred.promise;
  }

  /**
   * Returns total sales between start and end grouped by interval and item category.
   *
   * @memberof ReportItemCategories
   * @param  {String} start start of report period
   * @param  {String} end end of report period
   * @param  {String} interval TimeSpan format string
   * @return {Object} Service promise
   */
  function getSalesByInterval(start, end, interval) {
    return ItemCategorySales.query({start: start, end: end, interval: interval}).$promise;
  }

  /**
   * Returns total sales between start and end grouped by interval and item category.
   *
   * @memberof ReportItemCategories
   * @param  {String} start start of report period
   * @param  {String} end end of report period
   * @param  {String} interval TimeSpan format string
   * @return {Object} Service promise
   */
  function getOrdersByInterval(start, end, interval) {
    return ItemCategoryOrders.query({start: start, end: end, interval: interval}).$promise;
  }

  return {
    getSales: getSales,
    getSalesByInterval: getSalesByInterval,
    getOrders: getOrders,
    getOrdersByInterval: getOrdersByInterval
  };
}]);
